import { RaffleV2Type } from 'jigsaw';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Link,
  Text,
} from 'ui_2';

type Props = {
  type: RaffleV2Type;
};
export const HowGiveawaysWork = ({ type }: Props) => {
  return (
    <Accordion type='single' collapsible>
      <AccordionItem value='termsAndConditions'>
        <AccordionTrigger>
          <Text font='medium-sm'>How Giveaways work</Text>
        </AccordionTrigger>
        <AccordionContent>
          <ol className='list-decimal pb-2 pl-5'>
            <li className='mb-2'>
              <Text font='sm'>
                Use your Puzzle Arcade Tickets (PART) to enter the giveaway.
              </Text>
            </li>
            <li className='mb-2'>
              {type === RaffleV2Type.eth && (
                <Text font='sm'>
                  This giveaway prize is an Ethereum private keys that hold the
                  on-chain prize.
                </Text>
              )}
              {type === RaffleV2Type.product && (
                <Text font='sm'>
                  This giveaway prize is an gift card that hold the on-chain
                  prize. <strong>Note:</strong> make sure the gift card is
                  available in your country before entering!
                </Text>
              )}
            </li>
            <li className='mb-2'>
              <Text font='sm'>
                Giveaways are operated fully onchain, so you can trust they are
                executed fairly. (More on this{' '}
                <Link
                  href='https://puzzle.online/blog-detail/introducing-puzzle-zkgames-and-giveaways-on-aleo'
                  target='_blank'
                >
                  here
                </Link>
                ).
              </Text>
            </li>
            {type === RaffleV2Type.eth && (
              <li className='mb-4'>
                <Text font='sm'>
                  Winners have 7 days to remove the funds from the provided
                  Ethereum account. If the funds are not removed, they will be
                  added to the next giveaway.
                </Text>
              </li>
            )}
          </ol>
          <Text font='sm'>
            Reach out to us{' '}
            <Link href='https://discord.gg/puzzlearcade' target='_blank'>
              on our discord
            </Link>{' '}
            for help.
          </Text>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
